import BillingPeriodStatus from "../../entities/BillingPeriodStatus";

class ChildAgencyBillingPeriodResponse {
    public id: string;
    public description: string;
    public startDate: number;
    public endDate: number;
    public status: BillingPeriodStatus;
    public childAgencyAmount: number;

    constructor(id: string, description: string, startDate: number, endDate: number, status: BillingPeriodStatus, childAgencyAmount: number) {
        this.id = id;
        this.description = description;
        this.startDate = startDate;
        this.endDate = endDate;
        this.status = status;
        this.childAgencyAmount = childAgencyAmount;
    }
}

export default ChildAgencyBillingPeriodResponse;